<div class="terms-modal-container">
  <!-- Header -->
  <div class="terms-header">
    <svg lucideFileText [size]="48" class="terms-icon"></svg>
    <h2 class="terms-title">Terms of Service</h2>
    <p class="terms-subtitle">
      Please read and accept our Terms of Service to continue using the platform.
    </p>
  </div>

  <!-- Terms Content -->
  <div class="terms-content">
    <div class="terms-scroll-container">
      <div class="terms-text">
        <h3>1. Acceptance of Terms</h3>
        <p>
          By accessing and using the Science of Sports platform, you accept and agree to be bound by the terms and provision of this agreement.
        </p>

        <h3>2. Use License</h3>
        <p>
          Permission is granted to temporarily download one copy of the materials on Science of Sports' website for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:
        </p>
        <ul>
          <li>modify or copy the materials;</li>
          <li>use the materials for any commercial purpose or for any public display (commercial or non-commercial);</li>
          <li>attempt to decompile or reverse engineer any software contained on Science of Sports' website;</li>
          <li>remove any copyright or other proprietary notations from the materials.</li>
        </ul>

        <h3>3. Disclaimer</h3>
        <p>
          The materials on Science of Sports' website are provided on an 'as is' basis. Science of Sports makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.
        </p>

        <h3>4. Limitations</h3>
        <p>
          In no event shall Science of Sports or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on Science of Sports' website, even if Science of Sports or a Science of Sports authorized representative has been notified orally or in writing of the possibility of such damage.
        </p>

        <h3>5. Privacy Policy</h3>
        <p>
          Your privacy is important to us. Our Privacy Policy explains how we collect, use, and protect your information when you use our service. By using our service, you agree to the collection and use of information in accordance with our Privacy Policy.
        </p>

        <h3>6. User Accounts</h3>
        <p>
          When you create an account with us, you must provide information that is accurate, complete, and current at all times. You are responsible for safeguarding the password and for all activities that occur under your account.
        </p>

        <h3>7. Data Protection</h3>
        <p>
          We implement appropriate security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the Internet or electronic storage is 100% secure.
        </p>

        <h3>8. Modifications</h3>
        <p>
          Science of Sports may revise these terms of service for its website at any time without notice. By using this website, you are agreeing to be bound by the then current version of these terms of service.
        </p>

        <h3>9. Contact Information</h3>
        <p>
          If you have any questions about these Terms of Service, please contact us at support@scienceofsports.net.
        </p>
      </div>
    </div>
  </div>

  <!-- Form and Actions -->
  <form [formGroup]="termsForm" (ngSubmit)="onAccept()" class="terms-form">
    <div class="terms-checkbox-container">
      <mat-checkbox
        formControlName="acceptTerms"
        class="terms-checkbox"
        [class.error]="acceptTermsControl?.invalid && acceptTermsControl?.touched">
        I have read and agree to the Terms of Service
      </mat-checkbox>

      @if (acceptTermsControl?.invalid && acceptTermsControl?.touched) {
        <div class="error-message">
          <svg lucideCircleAlert [size]="20"></svg>
          You must accept the Terms of Service to continue
        </div>
      }
    </div>

    <div class="terms-actions">
      <button
        mat-raised-button
        color="primary"
        type="submit"
        class="accept-button"
        [disabled]="isAcceptButtonDisabled">
        @if (isAccepting()) {
          <mat-spinner diameter="20" class="button-spinner"></mat-spinner>
          Accepting...
        } @else {
          <ng-container>
            <svg lucideCheck [size]="20"></svg>
            Accept Terms
          </ng-container>
        }
      </button>
    </div>
  </form>
</div>
